// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".directory-content .form-thead{background-color:#2cb774;color:#fff;font-size:16px}.directory-content .btn-outline-secondary,.directory-content .form-tbody{color:#666}.directory-content .table-striped tbody tr:nth-of-type(odd){background-color:#fff}.directory-content .table-striped tbody tr:nth-of-type(2n){background-color:#eef9f4}.directory-content .table td,.directory-content .table th{border:none}.directory-content .btn-outline-secondary:hover{background-color:transparent}", ""]);
// Exports
module.exports = exports;
